module.exports = __webpack_public_path__ + "static/media/hero-image.fbf5e532.webp";